// extracted by mini-css-extract-plugin
export var formContainer = "_m5-0";
export var message = "_m5-1";